(function () {
  function initYoutubeSection(root) {
    if (!root || root.dataset.youtubeSectionInitialized === 'true') {
      return;
    }

    var track = root.querySelector('[data-youtube-track]');
    var btnPrev = root.querySelector('[data-youtube-prev]');
    var btnNext = root.querySelector('[data-youtube-next]');
    var thumbs = root.querySelectorAll('[data-youtube-thumb]');
    var modal = root.querySelector('[data-youtube-modal]');
    var iframe = root.querySelector('[data-youtube-player]');
    var closeBtn = root.querySelector('[data-youtube-close]');

    if (!track || !btnPrev || !btnNext || !modal || !iframe || !closeBtn) {
      return;
    }

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function openModal(id) {
      var src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.setAttribute('src', src);
      modal.classList.remove('is-hidden');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      iframe.setAttribute('src', '');
      modal.classList.add('is-hidden');
      document.documentElement.style.overflow = '';
    }

    function scrollByAmount(direction) {
      var card = root.querySelector('[data-youtube-thumb]');
      var step = card ? card.getBoundingClientRect().width + 16 : 320;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    thumbs.forEach(function (thumb) {
      function trigger() {
        var id = thumb.getAttribute('data-video-id');
        if (id) {
          openModal(id);
        }
      }

      thumb.addEventListener('click', trigger);
      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger();
        }
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    btnPrev.addEventListener('click', function () {
      scrollByAmount(-1);
    });

    btnNext.addEventListener('click', function () {
      scrollByAmount(1);
    });

    root.youtubeSectionCloseModal = closeModal;
    root.youtubeSectionModal = modal;
    root.dataset.youtubeSectionInitialized = 'true';
  }

  function initAllYoutubeSections(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-youtube-section]').forEach(initYoutubeSection);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('[data-youtube-section]').forEach(function (root) {
      var modal = root.youtubeSectionModal || root.querySelector('[data-youtube-modal]');
      if (modal && !modal.classList.contains('is-hidden') && root.youtubeSectionCloseModal) {
        root.youtubeSectionCloseModal();
      }
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllYoutubeSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-youtube-section]').forEach(function (root) {
      if (root.youtubeSectionModal && root.youtubeSectionModal.parentElement === document.body) {
        root.youtubeSectionModal.remove();
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllYoutubeSections(document);
    });
  } else {
    initAllYoutubeSections(document);
  }
})();
